export const infoCard = {
	seeDatails: "Ver detalles",
};
